import { CYCLE_COUNTERS } from '../globals';
export const isPartOfACycle = (audioNode) => {
    return CYCLE_COUNTERS.has(audioNode);
};
//# sourceMappingURL=is-part-of-a-cycle.js.map